export default {
  'user.query.deptKeyword.placeholder': 'Enter keyword to filter',
  'user.query.nickname': 'User Name',
  'user.query.nickname.placeholder': 'Enter user name',
  'user.query.mobile': 'Mobile Number',
  'user.query.mobile.placeholder': 'Enter mobile',
  'user.query.username': 'Login Name',
  'user.query.username.placeholder': 'Enter login name',
  'user.query.lastActiveTime': 'Last Active Time',
  'user.query.lastActiveTime.start-placeholder': 'Start Time',
  'user.query.lastActiveTime.end-placeholder': 'End Time',
  'user.column.username': 'Login Name',
  'user.column.nickname': 'Nickname',
  'user.column.deptId': 'Department',
  'user.column.mobile': 'Mobile',
  'user.column.status': 'Status',
  'user.column.lastActiveTime': 'Last Active Time',
  'user.column.operation.more': 'More',
  'user.column.operation.resetPwd': 'Reset Password',
  'user.column.operation.assignRole': 'Assign Role',
  'user.confirm.resetPwd.message': 'Please enter a new password for "{nickname}"',
  'user.confirm.resetPwd.errorMessage': 'Password length must be between 6 to 20 characters',
  'user.confirm.resetPwd.successMessage': 'Password reset successful, the new password is: {newPassword}',
  'user.confirm.toggleStatus.message': 'Are you sure you want to {status} "{nickname}"?',
  'user.confirm.toggleStatus.success': '{status} Successful',
  // assign role
  'user.assignRole.title': 'Assign Role',
  'user.assignRole.role.placeholder': 'Select a role',
  'user.assignRole.success': 'Role assigned successfully',
  // edit
  'user.edit.title': 'Edit User',
  'user.edit.success': 'Successfully Modified',
  'user.add.title': 'Add User',
  'user.add.success': 'Successfully Added, the default password is: {password}',
  'user.edit.form.nickname': 'User Nickname',
  'user.edit.form.nickname.placeholder': 'Please enter user nickname',
  'user.edit.form.nickname.required': 'Please enter user nickname',
  'user.edit.form.username': 'Login Name',
  'user.edit.form.username.placeholder': 'Please enter login name',
  'user.edit.form.username.required': 'Please enter login name',
  'user.edit.form.mobile': 'Mobile Number',
  'user.edit.form.mobile.placeholder': 'Please enter mobile number',
  'user.edit.form.mobile.required': 'Please enter mobile number',
  'user.edit.form.mobile.pattern': 'Incorrect mobile number format',
  'user.edit.form.sex': 'User Sex',
  'user.edit.form.sex.required': 'Please select user sex',
  'user.edit.form.sex.man': 'Male',
  'user.edit.form.sex.woman': 'Female',
  'user.edit.form.email': 'Email',
  'user.edit.form.email.placeholder': 'Please enter email',
  'user.edit.form.deptId': 'Department',
  'user.edit.form.deptId.placeholder': 'Select a department',
  'user.edit.form.postIds': 'Position',
  'user.edit.form.postIds.placeholder': 'Select a position',
  'user.edit.form.roleIds': 'Role',
  'user.edit.form.roleIds.placeholder': 'Select a role',
  'user.edit.form.remark': 'Remark',
  'user.edit.form.remark.placeholder': 'Enter content',
}
